export default (eventId) => `/bet_builder/${eventId}`;
